import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Register from "./pages/Register";
import Login from "./pages/Login";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import UsersAdmin from "./pages/admin/UsersAdmin";
import FamiliasAdmin from "./pages/admin/FamiliasAdmin";
import PadresPortal from "./pages/PadresPortal";
import TemasAdmin from "./pages/admin/TemasAdmin";
import LigasAdmin from "./pages/admin/LigasAdmin";
import GamificacionAdmin from "./pages/admin/GamificacionAdmin";
import AssistantAdmin from "./pages/admin/AssistantAdmin";
import ReflexionesAdmin from "./pages/admin/ReflexionesAdmin";
import EvidenciasAdmin from "./pages/admin/EvidenciasAdmin";
import CampusAdmin from "./pages/admin/CampusAdmin";
import SuperaXAdmin from "./pages/admin/SuperaXAdmin";
import GraduacionAdmin from "./pages/admin/GraduacionAdmin";
import ReferenciasAdmin from "./pages/admin/ReferenciasAdmin";
import FrasesAdmin from "./pages/admin/FrasesAdmin";
import SplashAdmin from "./pages/admin/SplashAdmin";
import NotificacionesAdmin from "./pages/admin/NotificacionesAdmin";
import UserDashboard from "./pages/UserDashboard";
import UserProfile from "./pages/UserProfile";
import ChatIntro from "./pages/ChatIntro";
import ChatStaff from "./pages/ChatStaff";
import AssistantPage from "./pages/AssistantPage";
import ChatConsole from "./pages/admin/ChatConsole";
import ChatGestion from "./pages/admin/ChatGestion";
import Compromisos from "./pages/Compromisos";
import Validaciones from "./pages/Validaciones";
import CompromisosAdmin from "./pages/admin/CompromisosAdmin";
import CampusUser from "./pages/CampusUser";
import InstructorPortal from "./pages/InstructorPortal";
import SuperaX from "./pages/SuperaX";
import NexusUser from "./pages/NexusUser";
import NexusAdmin from "./pages/admin/NexusAdmin";
import RaceUser from "./pages/RaceUser";
import RaceAdmin from "./pages/admin/RaceAdmin";
import GraduacionUser from "./pages/GraduacionUser";
import Ranking from "./pages/Ranking";
import Financiamiento from "./pages/Financiamiento";
import Suspendido from "./pages/Suspendido";
import FinanzasAdmin from "./pages/admin/FinanzasAdmin";
import DriveAdmin from "./pages/admin/DriveAdmin";
import DrivePublic from "./pages/DrivePublic";
import ConnectAdmin from "./pages/admin/ConnectAdmin";
import GuestPortal from "./pages/GuestPortal";
import GuestsAdmin from "./pages/admin/GuestsAdmin";
import CorreosAdmin from "./pages/admin/CorreosAdmin";
import PerfilAdmin from "./pages/admin/PerfilAdmin";
import InversoresAdmin from "./pages/admin/InversoresAdmin";
import InversoresPortal from "./pages/InversoresPortal";
import DocentesAdmin from "./pages/admin/DocentesAdmin";
import DocentePortal from "./pages/DocentePortal";
import CoachPanel from "./pages/CoachPanel";
import FuerzasAdmin from "./pages/admin/FuerzasAdmin";
import CapacitacionesAdmin from "./pages/admin/CapacitacionesAdmin";
import AnaAdmin from "./pages/admin/AnaAdmin";
import Capacitaciones from "./pages/Capacitaciones";
import CapacitacionPublica from "./pages/CapacitacionPublica";
import ReporteAna from "./pages/ReporteAna";
import { AppBadgeManager } from "./components/AppBadgeManager";
import ConnectHome from "./pages/ConnectHome";
import LiveSessions from "./pages/LiveSessions";
import SuperaConnectRoom from "./pages/SuperaConnectRoom";
import PWAControls from "./components/PWAControls";
import SplashScreen from "./components/SplashScreen";
import RaceResumeBanner from "./components/RaceResumeBanner";
import LangSwitch from "./components/LangSwitch";
import DomTranslator from "./i18n/DomTranslator";
import { LanguageProvider } from "./i18n/LanguageContext";
import { isAuthed, financeApi, getUser, isCoach, capacitacionApi, updateStoredUser } from "./lib/api";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { UpdateBanner } from "./components/UpdateBanner";
import { toast } from "sonner";

const ONBOARDING_OK = ["/capacitaciones", "/financiamiento", "/suspendido"];

function ProtectedUser({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAuthed()) return;
    financeApi.status().then((s) => {
      if (s.suspendido_manual) {
        if (location.pathname !== "/suspendido") navigate("/suspendido", { replace: true });
      } else if (s.suspendido && location.pathname !== "/financiamiento") {
        navigate("/financiamiento", { replace: true });
      }
    }).catch(() => {});
    if (getUser()?.role === "user") {
      capacitacionApi.estado().then((e) => {
        updateStoredUser({ requires_onboarding: e.bloqueado });
        if (e.bloqueado && !ONBOARDING_OK.includes(location.pathname)) navigate("/capacitaciones", { replace: true });
      }).catch(() => {});
    }
  }, [location.pathname, navigate]);
  if (!isAuthed()) return <Navigate to="/login" replace />;
  // Bloqueo total de onboarding: sin Capacitación aprobada no se accede a nada más.
  if (getUser()?.requires_onboarding && !ONBOARDING_OK.includes(location.pathname)) return <Navigate to="/capacitaciones" replace />;
  // Los invitados especiales solo acceden a su portal, chat, asistente y perfil.
  if (getUser()?.role === "invitado") {
    const GUEST_OK = ["/invitados", "/chat", "/chat/staff", "/asistente", "/mi-perfil", "/suspendido"];
    if (!GUEST_OK.includes(location.pathname)) return <Navigate to="/invitados" replace />;
  }
  // Los inversores Supera solo acceden a su portal privado y a sus reuniones Supera Connect.
  if (getUser()?.role === "inversor") {
    const p = location.pathname;
    const ok = p === "/inversores" || p.startsWith("/connect/room/");
    if (!ok) return <Navigate to="/inversores" replace />;
  }
  // Los docentes de colegios acceden a su portal, chat, asistente y salas Connect.
  if (getUser()?.role === "docente") {
    const p = location.pathname;
    const DOC_OK = ["/docentes", "/chat", "/chat/staff", "/asistente", "/mi-perfil", "/suspendido"];
    if (!(DOC_OK.includes(p) || p.startsWith("/connect/room/"))) return <Navigate to="/docentes" replace />;
  }
  // Coach Junior / Head Coach: solo su panel y las herramientas enlazadas.
  if (isCoach()) {
    const p = location.pathname;
    const COACH_OK = ["/coach", "/connect", "/chat", "/chat/staff", "/asistente", "/financiamiento", "/carrera", "/campus", "/nexus", "/mi-perfil", "/suspendido", "/capacitaciones"];
    if (!(COACH_OK.includes(p) || p.startsWith("/connect/room/"))) return <Navigate to="/coach" replace />;
  }
  return children;
}

function UserI18nLayer() {
  const location = useLocation();
  const p = location.pathname;
  // El panel admin se queda en español; la sala en vivo se omite por rendimiento/real-time.
  const isAdmin = p === "/admin" || p.startsWith("/admin/");
  const isRoom = p.startsWith("/connect/room/");
  if (isAdmin || isRoom) return null;
  return (
    <>
      <DomTranslator />
      <LangSwitch />
    </>
  );
}

function App() {
  useEffect(() => {
    document.title = "Supera Leadership · Formamos líderes";
    try {
      const reason = sessionStorage.getItem("supera_logout_reason");
      if (reason) {
        sessionStorage.removeItem("supera_logout_reason");
        setTimeout(() => toast.warning(reason, { duration: 6000 }), 400);
      }
    } catch {}
  }, []);

  return (
    <div className="App">
      <SplashScreen />
      <LanguageProvider>
        <BrowserRouter>
          <AppBadgeManager />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/registro/:programId" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/mi-cuenta" element={<ProtectedUser><UserDashboard /></ProtectedUser>} />
            <Route path="/mi-perfil" element={<ProtectedUser><UserProfile /></ProtectedUser>} />
            <Route path="/chat" element={<ProtectedUser><ChatIntro /></ProtectedUser>} />
            <Route path="/chat/staff" element={<ProtectedUser><ChatStaff /></ProtectedUser>} />
            <Route path="/asistente" element={<ProtectedUser><AssistantPage /></ProtectedUser>} />
            <Route path="/compromisos" element={<ProtectedUser><Compromisos /></ProtectedUser>} />
            <Route path="/validaciones" element={<ProtectedUser><Validaciones /></ProtectedUser>} />
            <Route path="/padres" element={<ProtectedUser><PadresPortal /></ProtectedUser>} />
            <Route path="/campus" element={<ProtectedUser><CampusUser /></ProtectedUser>} />
            <Route path="/instructor" element={<ProtectedUser><InstructorPortal /></ProtectedUser>} />
            <Route path="/connect" element={<ProtectedUser><ConnectHome /></ProtectedUser>} />
            <Route path="/connect/room/:sessionId" element={<ProtectedUser><SuperaConnectRoom /></ProtectedUser>} />
            <Route path="/en-vivo" element={<ProtectedUser><LiveSessions /></ProtectedUser>} />
            <Route path="/superax" element={<ProtectedUser><SuperaX /></ProtectedUser>} />
            <Route path="/nexus" element={<ProtectedUser><NexusUser /></ProtectedUser>} />
            <Route path="/carrera" element={<ProtectedUser><RaceUser /></ProtectedUser>} />
            <Route path="/invitados" element={<ProtectedUser><GuestPortal /></ProtectedUser>} />
            <Route path="/inversores" element={<ProtectedUser><InversoresPortal /></ProtectedUser>} />
            <Route path="/docentes" element={<ProtectedUser><DocentePortal /></ProtectedUser>} />
            <Route path="/coach" element={<ProtectedUser><CoachPanel /></ProtectedUser>} />
            <Route path="/graduacion" element={<ProtectedUser><GraduacionUser /></ProtectedUser>} />
            <Route path="/ranking" element={<ProtectedUser><Ranking /></ProtectedUser>} />
            <Route path="/financiamiento" element={<ProtectedUser><Financiamiento /></ProtectedUser>} />
            <Route path="/suspendido" element={<Suspendido />} />
            <Route path="/capacitaciones" element={<ProtectedUser><Capacitaciones /></ProtectedUser>} />
            <Route path="/capacitacion" element={<CapacitacionPublica />} />
            <Route path="/reporte-ana/:id" element={<ProtectedUser><ReporteAna /></ProtectedUser>} />
            <Route path="/capacitacion/:token" element={<CapacitacionPublica />} />
            <Route path="/d/:token" element={<DrivePublic />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="usuarios" element={<UsersAdmin />} />
              <Route path="familias" element={<FamiliasAdmin />} />
              <Route path="temas" element={<TemasAdmin />} />
              <Route path="ligas" element={<LigasAdmin />} />
              <Route path="gamificacion" element={<GamificacionAdmin />} />
              <Route path="asistente" element={<AssistantAdmin />} />
              <Route path="reflexiones" element={<ReflexionesAdmin />} />
              <Route path="evidencias" element={<EvidenciasAdmin />} />
              <Route path="campus" element={<CampusAdmin />} />
              <Route path="superax" element={<SuperaXAdmin />} />
              <Route path="graduacion" element={<GraduacionAdmin />} />
              <Route path="referencias" element={<ReferenciasAdmin />} />
              <Route path="frases" element={<FrasesAdmin />} />
              <Route path="frases-splash" element={<SplashAdmin />} />
              <Route path="notificaciones" element={<NotificacionesAdmin />} />
              <Route path="finanzas" element={<FinanzasAdmin />} />
              <Route path="chat" element={<ChatConsole />} />
              <Route path="chat-gestion" element={<ChatGestion />} />
              <Route path="compromisos" element={<CompromisosAdmin />} />
              <Route path="drive" element={<DriveAdmin />} />
              <Route path="connect" element={<ConnectAdmin />} />
              <Route path="invitados" element={<GuestsAdmin />} />
              <Route path="nexus" element={<NexusAdmin />} />
              <Route path="carrera" element={<RaceAdmin />} />
              <Route path="correos" element={<CorreosAdmin />} />
              <Route path="inversores" element={<InversoresAdmin />} />
              <Route path="docentes" element={<DocentesAdmin />} />
              <Route path="fuerzas" element={<FuerzasAdmin />} />
              <Route path="capacitaciones" element={<CapacitacionesAdmin />} />
              <Route path="ana" element={<AnaAdmin />} />
              <Route path="perfil" element={<PerfilAdmin />} />
            </Route>
          </Routes>
          <UserI18nLayer />
          <RaceResumeBanner />
        </BrowserRouter>
        <PWAControls />
        <Toaster position="top-center" richColors />
        <UpdateBanner />
      </LanguageProvider>
    </div>
  );
}

export default App;
